/*
* <license header>
*/

/** Adobe Recommended App Builder types (npm package templates) */
export const APP_TYPES = [
  {
    slug: 'generator-app-asset-compute',
    package: '@adobe/generator-app-asset-compute',
    version: '3.0.0',
    title: 'Asset Compute',
    badge: 'Application',
    description: 'Extensibility template for generator-aio-app',
    publishDate: 'June 8, 2022',
    recommended: true
  },
  {
    slug: 'generator-app-excshell',
    package: '@adobe/generator-app-excshell',
    version: '2.0.0',
    title: 'Exc Shell',
    badge: 'Application',
    description: 'Extensibility template for generator-aio-app',
    publishDate: 'August 25, 2022',
    recommended: true
  },
  {
    slug: 'generator-app-api-mesh',
    package: '@adobe/generator-app-api-mesh',
    version: '0.3.1',
    title: 'API Mesh',
    badge: 'Mesh',
    description: 'Extensibility template for Adobe API Mesh, for App Builder',
    publishDate: 'August 30, 2022',
    recommended: true
  },
  {
    slug: 'aem-cf-admin-ui-ext-tpl',
    package: '@adobe/aem-cf-admin-ui-ext-tpl',
    version: '2.1.0',
    title: 'AEM Content Fragment Admin',
    badge: 'Extension',
    description: 'Extensibility template for AEM Content Fragment Admin Console',
    publishDate: 'October 3, 2022',
    recommended: true
  },
  {
    slug: 'generator-app-aem-react',
    package: '@adobe/generator-app-aem-react',
    version: '0.0.1-beta.6',
    title: 'AEM React SPA',
    badge: 'Application',
    description: 'Template for AEM React SPA based on WKND content.',
    publishDate: 'November 1, 2022',
    recommended: true
  },
  {
    slug: 'aem-cf-editor-ui-ext-tpl',
    package: '@adobe/aem-cf-editor-ui-ext-tpl',
    version: '2.1.0',
    title: 'AEM Content Fragment Editor',
    badge: 'Extension',
    description: 'Extensibility template for AEM Content Fragment Editor',
    publishDate: 'April 26, 2023',
    recommended: true
  },
  {
    slug: 'generator-app-events-generic',
    package: '@adobe/generator-app-events-generic',
    version: '2.0.1',
    title: 'Events Generic',
    badge: 'API',
    description: 'Adds event registrations and a generic action',
    publishDate: 'September 6, 2023',
    recommended: true
  },
  {
    slug: 'workfront-ui-ext-tpl',
    package: '@adobe/workfront-ui-ext-tpl',
    version: '0.0.7',
    title: 'Workfront UI Extension',
    badge: 'Extension',
    description: 'Template for AIO CLI App Builder plugin that allows generating code of UI Extension for Workfront product',
    publishDate: 'August 23, 2024',
    recommended: true
  },
  {
    slug: 'aem-assets-details-ext-tpl',
    package: '@adobe/aem-assets-details-ext-tpl',
    version: '0.0.7',
    title: 'AEM Assets Details',
    badge: 'Extension',
    description: 'Asset Details extension template for the AEM Assets View',
    publishDate: 'October 29, 2024',
    recommended: true
  },
  {
    slug: 'universal-editor-ui-ext-tpl',
    package: '@adobe/universal-editor-ui-ext-tpl',
    version: '1.0.0-beta.1',
    title: 'Universal Editor',
    badge: 'Extension',
    description: 'Extensibility Template for Universal Editor',
    publishDate: 'December 17, 2024',
    recommended: true
  },
  {
    slug: 'aem-assets-browse-ext-tpl',
    package: '@adobe/aem-assets-browse-ext-tpl',
    version: '0.0.3',
    title: 'AEM Assets Browse',
    badge: 'Extension',
    description: 'Asset Browse extension template for the AEM Assets View',
    publishDate: 'June 3, 2025',
    recommended: true
  },
  {
    slug: 'aem-experience-hub-ext-tpl',
    package: '@adobe/aem-experience-hub-ext-tpl',
    version: '0.0.21',
    title: 'AEM Experience Hub',
    badge: 'Extension',
    description: 'Extension template for AEM Experience Hub',
    publishDate: 'October 1, 2025',
    recommended: true
  },
  {
    slug: 'generator-app-remote-mcp-server-generic',
    package: '@adobe/generator-app-remote-mcp-server-generic',
    version: '0.1.9',
    title: 'MCP Server Generic',
    badge: 'API',
    description: 'Adobe I/O Appbuilder template for MCP server implementation with Appbuilder actions.',
    publishDate: 'October 31, 2025',
    recommended: true
  }
]

/** Real-world App Builder examples and templates for development reference */
export const APP_TEMPLATES = [
  {
    slug: 'aem-dam-push-assets',
    title: 'Push Assets to 3rd Party System from AEM DAM Events',
    badge: 'Integration',
    description: 'Automatically sync digital assets from Adobe Experience Manager Assets to external systems (e.g., DAM, PIM, CDN) when assets are published or updated. Uses Adobe I/O Events to listen for asset ingestion and metadata changes, then triggers serverless actions to push renditions and metadata to your target system.',
    githubUrl: 'https://github.com/adobe/appbuilder-templates/aem-dam-push-assets',
    useCase: 'Content syndication, multi-DAM workflows, brand portal sync',
    appBuilderType: 'Events Generic',
    technologies: ['Adobe I/O Events', 'Adobe I/O Runtime', 'AEM Assets API', 'Node.js']
  },
  {
    slug: 'genstudio-content-certification',
    title: 'GenStudio Content Certification Extension',
    badge: 'Extension',
    description: 'Unified Shell extension that integrates with Adobe GenStudio to review, approve, and certify AI-generated content before publication. Provides workflow controls, approval queues, and audit trails for content governance. Built as a React SPA extension within the Adobe Unified Shell.',
    githubUrl: 'https://github.com/adobe/appbuilder-templates/genstudio-content-certification',
    useCase: 'AI content governance, approval workflows, compliance tracking',
    appBuilderType: 'Exc Shell',
    technologies: ['React', 'Unified Shell', 'GenStudio API', 'Spectrum']
  },
  {
    slug: 'api-endpoint-adobe-integration',
    title: 'API Endpoint for 3rd Party System Integration with Adobe Products',
    badge: 'API',
    description: 'Serverless API endpoints that bridge external systems (CRM, ERP, marketing tools) with Adobe products. Handles authentication, data transformation, and webhook callbacks. Use Adobe I/O Runtime actions to expose REST endpoints that sync data bidirectionally between your systems and Adobe Experience Cloud.',
    githubUrl: 'https://github.com/adobe/appbuilder-templates/api-endpoint-adobe-integration',
    useCase: 'Data sync, webhook integrations, custom connectors',
    appBuilderType: 'Events Generic',
    technologies: ['Adobe I/O Runtime', 'REST API', 'Webhooks', 'OAuth']
  },
  {
    slug: 'operational-dashboard-shell',
    title: 'Operational Dashboard (Unified Shell Extension)',
    badge: 'Extension',
    description: 'A unified shell extension providing a centralized operational dashboard for monitoring deployments, API usage, event delivery status, and system health across Adobe App Builder applications. Aggregates metrics from multiple services into a single pane with drill-down capabilities.',
    githubUrl: 'https://github.com/adobe/appbuilder-templates/operational-dashboard',
    useCase: 'Operations monitoring, DevOps visibility, SLA tracking',
    appBuilderType: 'Exc Shell',
    technologies: ['React', 'Unified Shell', 'Adobe I/O Runtime', 'Chart.js']
  }
]

export const APPS = [
  {
    id: '1',
    title: 'App 1',
    status: 'green',
    description: 'Unified Shell application for content management with custom extensions and integrations.'
  },
  {
    id: '2',
    title: 'App 2',
    status: 'yellow',
    description: 'GenStudio extension in draft state. Configure parameters and deploy when ready.'
  },
  {
    id: '3',
    title: 'App 3',
    status: 'red',
    description: 'API mesh configuration requires attention. Check deployment logs for details.'
  }
]
